export const SERVICES_ON_GET_ALL_REQUESTED = 'SERVICES_ON_GET_ALL_REQUESTED';
export const SERVICES_ON_GET_ALL_SUCCEEDED = 'SERVICES_ON_GET_ALL_SUCCEEDED';
export const SERVICES_ON_GET_ALL_FAILED = 'SERVICES_ON_GET_ALL_FAILED';
